export const hdmgdjDownloadSteps = [
  {
    id: "step-1",
    icon: "ri-device-line",
    title: "选择你的设备版本",
    desc: "在下方四个平台入口中，找到手机或电脑对应的系统版本。",
  },
  {
    id: "step-2",
    icon: "ri-download-2-line",
    title: "点击下载安装包",
    desc: "点击按钮后会跳转到官方下载地址，等待安装包下载完成。",
  },
  {
    id: "step-3",
    icon: "ri-rocket-2-line",
    title: "安装并打开黄豆魔改短剧",
    desc: "按提示完成安装，打开应用登录账号，即可畅看全部魔改短剧。",
  },
];

export const hdmgdjDownloadHighlights = [
  {
    id: "h-free",
    icon: "ri-gift-line",
    title: "完全免费",
    desc: "黄豆魔改短剧免费版下载后，全站剧目免费畅看。",
  },
  {
    id: "h-size",
    icon: "ri-database-2-line",
    title: "轻量安装",
    desc: "安装包体积小巧，老机型也能轻松装下。",
  },
  {
    id: "h-safe",
    icon: "ri-shield-check-line",
    title: "官方安全",
    desc: "安装包均来自官方渠道，无捆绑、无病毒。",
  },
  {
    id: "h-update",
    icon: "ri-refresh-line",
    title: "持续更新",
    desc: "剧场每日上新，安装一次长期畅看。",
  },
];